// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15npz","type":"styles_type__2mQym","choices":"styles_choices__2WjfJ"};